import React from 'react'
import './PrizeMoney.css'


export default function PrizeMoney() {
    const  prizeData=[
        {
            heading:"Top 3 winners",
            content:"The top three participants will be awarded exceptional prizes, recognizing their outstanding performance.",
            pic:"/prize_pic1.png"
        },
        {
            heading:"Course Discounts",
            content:"Every participant will receive a 5 - 10% discount on all our courses, as a token of our appreciation for your engagement.",
            pic:"/prize_pic2.png"
        },
        {
            heading:"Participation Certificates",
            content:"All valid submissions will be honored with a certificate of participation, acknowledging your valuable contribution.",
            pic:"/prize_pic3.png"
        },
    ]
  return (
    <div>    
        <p className='DatasetHeading'>JOIN US AND WIN EXCITING PRIZES</p>
        <div className='prizes_section'>
            {
                prizeData?.map((e,id)=>{
                    return(
                        <div key={id} className='eachPrize'>
                            <img src={e?.pic} alt='prize' className='prizePic'></img>
                            <p className='prizeheading'>{e?.heading}</p>
                            <p className='prizeContent'>{e?.content}</p>
                        </div>
                    )
                })
            }
           
        </div>
    </div>
  )
}
